import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70" role="contentinfo">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block">
              <span
                className="text-xl font-bold tracking-tight text-foreground-950"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                <span className="text-primary-500">91</span>吃瓜
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
              全网最真的瓜，91吃瓜社区不打烊更新。带你感受沉浸式吃瓜快乐，每日必看的吃瓜群众聚集地。
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors underline underline-offset-2"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/wanghong"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors underline underline-offset-2"
                >
                  网红圈
                </Link>
              </li>
              <li>
                <Link
                  to="/category/yule"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors underline underline-offset-2"
                >
                  娱乐圈
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors underline underline-offset-2"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-foreground-500" />
                </span>
                hello@cqxbygc.cn
              </li>
              <li className="text-sm text-foreground-600">
                本站内容来源于网络整理，仅供娱乐参考
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 91吃瓜社区 版权所有
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              隐私政策
            </span>
            <span className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              使用条款
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}